import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import image from './images/OGNIFYAR (1).png';
import { motion, AnimatePresence } from "framer-motion";

const Header = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = (e) => {
    e.stopPropagation();
    setDropdownOpen(!dropdownOpen);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  const services = [
    { name: "ServiceNow Migration", path: "/services/servicenow-migration" },
    { name: "Salesforce Expertise", path: "/services/salesforce-solutions" },
    { name: "Informatica Cloud", path: "/services/informatica-cloud" },
    { name: "Agentic AI & GenAI", path: "/services/agentic-ai-genai" },
    { name: "Power Apps", path: "/services/power-apps" },
    { name: "Microsoft Copilot", path: "/services/microsoft-copilot" },
    { name: "SAP BTP/HANA", path: "/services/sap-btp-hana" },
    { name: "Data Lake/Delta Lake", path: "/services/data-lake-delta-lake" }, // Added
    { name: "Unqork Automation", path: "/services/unqork-automation" }           // Added
];

  const dropdownVariants = {
    hidden: { 
      opacity: 0,
      y: -20,
      transition: {
        duration: 0.2,
        ease: "easeInOut"
      }
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        ease: "easeOut",
        staggerChildren: 0.05,
        when: "beforeChildren"
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: { opacity: 1, y: 0 }
  };


  

  return (
    <header className="header">
      <div className="logo">
        <Link to='/'>
          <img src={image} alt="Cognifyar Logo" />
        </Link>
      </div>
      <button className={`burger ${menuOpen ? "open" : ""}`} onClick={toggleMenu}>
        <span className="burger-line"></span>
        <span className="burger-line"></span>
        <span className="burger-line"></span>
      </button>
      <nav className={`nav ${menuOpen ? "open" : ""}`}>
        <ul className="main-nav">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li className="mega-menu-item" ref={dropdownRef}>
            <button 
              className="dropdown-toggle" 
              onClick={toggleDropdown}
              aria-expanded={dropdownOpen}
            >
              Our Services <span className={`dropdown-icon ${dropdownOpen ? "open" : ""}`}>&#9660;</span>
            </button>
            <AnimatePresence>
              {dropdownOpen && (
                <motion.div
                  className="mega-menu-dropdown"
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                  variants={dropdownVariants}
                >
                  <motion.div className="mega-menu-grid">
                    {services.map((link, index) => (
                      <motion.div
                        key={index}
                        variants={itemVariants}
                        whileHover={{ scale: 1.03 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <Link 
                          to={link.path} 
                          className="mega-menu-link"
                          onClick={() => {
                            setDropdownOpen(false);
                            setMenuOpen(false);
                          }}
                        >
                          {link.name}
                        </Link>
                      </motion.div>
                    ))}
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
          </li>
          <li>
            <Link to="/about">About</Link>
          </li>
          <li>
            <Link to="/careers">Careers</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;